// @core/composables/useLanguage.ts
import { ref, readonly } from 'vue'
import { lang as t } from '../langs'
// 全局状态
const currentLang = ref<string>('')
const languageList = ref<{ name: string; key: string }[]>([])
let globalStore: any = null
/**
 * 初始化语言系统
 */
export function initLanguage(
  defaultLang: string,
  supportedLangs: string[],
  store: any,
  langOptions: { name: string; key: string }[] // 👈 新增：语言选项列表
) {
  globalStore = store
  // 保存语言选项
  languageList.value = langOptions

  // ...（其余初始化逻辑不变）
  let finalLang =
    localStorage.getItem('language') || store.header?.language || defaultLang

  finalLang = finalLang.toLowerCase()

  if (!supportedLangs.includes(finalLang)) {
    finalLang = defaultLang.toLowerCase()
  }

  currentLang.value = finalLang
  localStorage.setItem('language', finalLang)

  if (store.header?.language !== finalLang) {
    store.setHeader({ ...store.header, language: finalLang })
  }

  try {
    document.title = t('创建订单')
  } catch (e) {
    console.warn('[i18n] Missing "创建订单"')
    document.title = 'Order System'
  }
}

export function setLanguage(langCode: string) {
  if (!globalStore) {
    throw new Error(
      '[i18n] Language not initialized. Call initLanguage() first.'
    )
  }
  const normalized = langCode.toLowerCase()
  currentLang.value = normalized
  localStorage.setItem('language', normalized)

  if (globalStore.header?.language !== normalized) {
    globalStore.setHeader({ ...globalStore.header, language: normalized })
  }

  try {
    document.title = t('创建订单')
  } catch (e) {
    console.warn(`[i18n] Missing "创建订单" in ${normalized}`)
  }
}

/**
 * 提供响应式语言能力
 */
export function useLanguage() {
  return {
    language: readonly(currentLang), // 只读
    langList: readonly(languageList), // 👈 暴露语言列表
    setLanguage,
    t
  }
}
